import { render, staticRenderFns } from "./finish_index.vue?vue&type=template&id=2ad8d2c0&scoped=true&"
import script from "./finish_index.vue?vue&type=script&lang=js&"
export * from "./finish_index.vue?vue&type=script&lang=js&"
import style0 from "./finish_index.vue?vue&type=style&index=0&id=2ad8d2c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad8d2c0",
  null
  
)

export default component.exports